import React, { useEffect, useState } from "react";
import AuthService from "../../AuthService";
import utils, { formatTextToFirstLetterUpperCase } from "../../utils";
import ForList from "./../Skeleton/ForList";

import { useSnackbar } from "notistack";

import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Grid,
  MenuItem,
  Paper,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  useMediaQuery,
  useTheme,
} from "@mui/material";

import AddIcon from "@mui/icons-material/Add";
import CancelIcon from "@mui/icons-material/Cancel";
import EditIcon from "@mui/icons-material/Edit";
import SaveIcon from "@mui/icons-material/Save";
import Utils from "../../utils";
import BarraTitulo from "../Generico/BarraTitulo";

export default function ConfiguracaoEntregaBairro() {
  const { enqueueSnackbar } = useSnackbar();
  const [bairroEntrega, setBairroEntrega] = useState({
    bairro: "",
    valor: 0.0,
    municipio: null,
    ativo: true,
  });
  const [municipios, setMunicipios] = useState([]);
  const [listaBairros, setListaBairros] = useState([]);
  const [paginations, setPaginations] = useState({
    page: 0,
    rowsPerPage: 10,
    totalCountPedidos: 0,
  });
  const [totalCountPedidos, setTotalCountPedidos] = useState(0);
  const [openNovoBairro, setOpenNovoBairro] = useState(false);
  const [skeleton, setSkeleton] = useState(false);
  const [erroCadastroBairro, setErroCadastroBairro] = useState({
    bairro: null,
    municipio: null,
  });
  const [pesquisaBairro, setPesquisaBairro] = useState("");
  const [bairrosAtivos, setBairrosAtivos] = useState(true);
  const theme = useTheme();
  const isTablet = useMediaQuery(theme.breakpoints.down("md"));
  const novaTaxa = () => {
    let taxa = {
      bairro: "",
      valor: 0.0,
      municipio: null,
      ativo: true,
    };

    setBairroEntrega(taxa);
  };

  useEffect(() => {
    handleListarBairros();
    handleGetMunicipios();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    handleListarBairros(bairrosAtivos);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paginations, bairrosAtivos]);

  const handleCriarNovoBairro = () => {
    setOpenNovoBairro(!openNovoBairro);
    handleGetMunicipios();

    novaTaxa();
  };
  const handleChange = (event, value) => {
    const taxaEntrega = Object.assign({}, bairroEntrega);

    utils.setValue(taxaEntrega, event.target.name, value || event.target.value);
    setBairroEntrega(taxaEntrega);
  };
  const handleChangeMunicipio = (event) => {
    let municipioId = event.target.value;
    setBairroEntrega({ ...bairroEntrega, municipio: { id: municipioId } });
  };

  const handleGetMunicipios = () => {
    let service = new AuthService();
    service
      .get("/permissaoMunicipio/listOrCreate?tipo=station")
      .then((resp) => {
        const municipiosResp = resp.map(
          (permissaoMunicipio) => permissaoMunicipio.municipio
        );
        setMunicipios(municipiosResp);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const handleSalvar = () => {
    let copiaBairroEntrega = Object.assign({}, bairroEntrega);
    copiaBairroEntrega.valor = Utils.replaceValor(bairroEntrega.valor);
    copiaBairroEntrega.bairro = formatTextToFirstLetterUpperCase(
      copiaBairroEntrega.bairro
    );

    let service = new AuthService();
    service
      .post("/bairroEntrega", copiaBairroEntrega)
      .then((resp) => {
        let pos = listaBairros
          .map(function (t) {
            return t.id;
          })
          .indexOf(bairroEntrega.id);

        if (pos >= 0) {
          listaBairros.splice(pos, 1);
        }

        let bairroEntregaResp = [];

        listaBairros.map((bairros) => bairroEntregaResp.push(bairros));

        bairroEntregaResp.push(resp);
        setListaBairros(bairroEntregaResp);
        setOpenNovoBairro(!openNovoBairro);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  //Lista os bairros ao carregar a página
  const handleListarBairros = (isActive) => {
    let copiaPaginations = Object.assign({}, paginations);
    setSkeleton(true);

    let service = new AuthService();
    service
      .request(
        `/bairroEntrega/list?ativo=${isActive}&first=${
          copiaPaginations.rowsPerPage * copiaPaginations.page
        }&max=${copiaPaginations.rowsPerPage}`
      )
      .then((resp) => {
        let totalCountPedidos = resp.headers.get("totalCount");
        setTotalCountPedidos(parseInt(totalCountPedidos));

        resp
          .json()
          .then((retorno) => {
            setListaBairros(retorno);
            setSkeleton(false);
          })
          .catch((err) => {
            console.error(err);
          });
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const handleChangePage = (event, newPage) => {
    setPaginations({ ...paginations, page: newPage });
  };

  const handleChangeRowsPerPage = (event) => {
    setPaginations({ page: 0, rowsPerPage: parseInt(event.target.value) });
  };

  //Edita o valor do bairro
  const handleEdit = (taxa) => {
    setOpenNovoBairro(!openNovoBairro);

    let bairro = JSON.parse(JSON.stringify(taxa));

    setBairroEntrega(bairro);
  };

  const handleValidarBairro = () => {
    let salvar = true;

    listaBairros.forEach((taxa) => {
      if (
        taxa.bairro === bairroEntrega.bairro &&
        taxa.municipio?.id === bairroEntrega.municipio?.id &&
        taxa.id !== bairroEntrega.id
      ) {
        enqueueSnackbar("Bairro já cadastrado", { variant: "error" });
        salvar = false;
      }
    });

    if (salvar) {
      handleSalvar();
    }
  };

  const handleValidarCampos = () => {
    var erros = { bairro: null, municipio: null };
    var erro = false;

    if (!bairroEntrega.bairro) {
      erros.bairro = "O campo bairro deve ser preenchido";
      erro = true;
    }

    if (!bairroEntrega.municipio) {
      erros.municipio = "Você deve selecionar um município";
      erro = true;
    }

    setErroCadastroBairro(erros);

    if (!erro) {
      handleValidarBairro();
    }
  };

  const handleChecked = (event) => {
    let valorAtivo = event.target.checked;
    setBairroEntrega({ ...bairroEntrega, ativo: valorAtivo });
  };

  const handleChangePesquisaBairro = (event) => {
    setPesquisaBairro(event.target.value);
  };

  const handlePesquisarBairro = () => {
    setSkeleton(true);

    let service = new AuthService();
    service
      .get(`/bairroEntrega/list?q=${pesquisaBairro}&ativo=${bairrosAtivos}`)
      .then((resp) => {
        setListaBairros(resp);
        setSkeleton(false);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const handleChangeAtivos = () => {
    setBairrosAtivos(!bairrosAtivos);
    setPaginations({ ...paginations, page: 0 });
  };

  const keyDown = (event) => {
    if (event === "click" || event.key === "Enter") {
      handlePesquisarBairro();
    }
  };

  return (
    <>
      <Box
        display="flex"
        flexDirection={isTablet ? "column" : "row"}
        justifyContent="space-between"
        alignItems="flex-end"
      >
        <Box sx={{ width: "100%" }}>
          <BarraTitulo
            title="Taxas por bairros"
            subTitle="Configure as taxa de entrega conforme o bairro"
          />
        </Box>

        <Box
          sx={{
            width: isTablet ? "100%" : "auto",
            minWidth: "10rem",
            marginBottom: "0.75rem",
          }}
        >
          <Button
            color="primary"
            variant="contained"
            startIcon={<AddIcon />}
            size="medium"
            fullWidth
            onClick={handleCriarNovoBairro}
          >
            Novo bairro
          </Button>
        </Box>
      </Box>
      <Paper sx={{ padding: "1rem" }}>
        <Grid
          sx={{ margin: "1rem" }}
          container
          spacing={isTablet ? 2 : 4}
          alignItems="center"
        >
          <Grid item size={{ xs: 12, md: 8 }}>
            <TextField
              variant="outlined"
              onChange={handleChangePesquisaBairro}
              label="Digite o nome do bairro"
              value={pesquisaBairro || ""}
              fullWidth
              onKeyPress={keyDown}
            />
          </Grid>

          <Grid item size={{ xs: 12, md: 2 }}>
            <Box
              display="flex"
              justifyContent={isTablet ? "flex-start" : "center"}
              alignItems="center"
            >
              <FormControlLabel
                control={
                  <Switch
                    checked={bairrosAtivos}
                    onChange={handleChangeAtivos}
                  />
                }
                label={bairrosAtivos ? "Bairros ativos" : "Bairros inativos"}
              />
            </Box>
          </Grid>

          <Grid item size={{ xs: 12, md: 2 }}>
            <Button
              color="primary"
              variant="contained"
              fullWidth
              size="medium"
              onClick={handlePesquisarBairro}
              sx={{ whiteSpace: "nowrap", height: "3.5rem" }}
            >
              Pesquisar
            </Button>
          </Grid>
        </Grid>

        <Box sx={{ margin: "2rem 0.5rem 0.5rem 0.5rem" }}>
          <TableContainer>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell>Bairro</TableCell>
                  <TableCell>Valor da taxa</TableCell>
                  <TableCell>Município</TableCell>
                  <TableCell>Situação</TableCell>
                  <TableCell></TableCell>
                </TableRow>
              </TableHead>

              {skeleton ? (
                <TableBody>
                  <TableRow>
                    <TableCell colSpan={12}>
                      <ForList rows={paginations.rowsPerPage} height={50} />
                    </TableCell>
                  </TableRow>
                </TableBody>
              ) : null}

              <TableBody>
                {listaBairros.map((taxa) => {
                  return (
                    <TableRow key={taxa.id}>
                      <TableCell>{taxa.bairro}</TableCell>

                      <TableCell>{utils.formatNumber(taxa.valor)}</TableCell>

                      <TableCell>{taxa.municipio?.nome}</TableCell>

                      <TableCell>{taxa.ativo ? "Ativo" : "Inativo"}</TableCell>

                      <TableCell scope="medium" align="right" xs={2}>
                        <Button
                          onClick={(event) => {
                            handleEdit(taxa);
                          }}
                          startIcon={<EditIcon />}
                        >
                          Editar
                        </Button>
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
            <TablePagination
              rowsPerPageOptions={[5, 10, 25]}
              component="div"
              labelRowsPerPage="Linhas por página"
              count={totalCountPedidos}
              rowsPerPage={paginations.rowsPerPage}
              page={paginations.page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </TableContainer>
        </Box>
        <Dialog open={openNovoBairro} onClose={handleCriarNovoBairro} fullWidth>
          <DialogTitle>Criar novo bairro</DialogTitle>

          <DialogContent>
            <Box p={2}>
              <Grid container spacing={2}>
                <Grid
                  size={{
                    xs: 12,
                    md: 6,
                  }}
                >
                  <TextField
                    variant="outlined"
                    name="bairro"
                    error={erroCadastroBairro.bairro !== null}
                    helperText={erroCadastroBairro.bairro}
                    defaultValue={bairroEntrega.bairro || ""}
                    onChange={(event) => {
                      handleChange(event);
                    }}
                    label="Bairro"
                    fullWidth
                  />
                </Grid>

                <Grid
                  size={{
                    xs: 12,
                    md: 6,
                  }}
                >
                  <TextField
                    variant="outlined"
                    name="valor"
                    value={bairroEntrega.valor || ""}
                    onChange={handleChange}
                    label="Taxa de entrega"
                    fullWidth
                    InputProps={{
                      startAdornment: <span>R$</span>,
                    }}
                    inputProps={{ maxLength: 15 }}
                  />
                </Grid>

                <Grid
                  size={{
                    xs: 12,
                    md: 12,
                  }}
                >
                  <TextField
                    id="selecionarMunicipio"
                    select
                    label="Municípios"
                    error={erroCadastroBairro.municipio !== null}
                    helperText={erroCadastroBairro.municipio}
                    value={
                      bairroEntrega.municipio?.id
                        ? bairroEntrega.municipio.id
                        : ""
                    }
                    name="municipio"
                    onChange={handleChangeMunicipio}
                    fullWidth
                    variant="outlined"
                  >
                    {municipios?.map((municipio) => (
                      <MenuItem key={municipio.id} value={municipio.id}>
                        {municipio.nome}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>
              </Grid>
            </Box>

            <Box style={{ marginLeft: "20px" }}>
              <FormControlLabel
                name="ativo"
                control={
                  <Switch
                    checked={bairroEntrega.ativo}
                    color="primary"
                    onChange={(event) => handleChecked(event)}
                  />
                }
                label={"Bairro ativo"}
              />
            </Box>

            <Box p={2} display="flex" justifyContent="flex-end">
              <Button
                color="primary"
                variant="text"
                onClick={handleCriarNovoBairro}
                startIcon={<CancelIcon />}
              >
                Cancelar
              </Button>
              <Button
                aria-expanded={true}
                variant="contained"
                onClick={handleValidarCampos}
                color="secondary"
                startIcon={<SaveIcon />}
              >
                Salvar
              </Button>
            </Box>
          </DialogContent>
        </Dialog>
      </Paper>
    </>
  );
}
